import React from 'react';
import { Helmet } from 'react-helmet';
import useToggle from '../../../Hooks/useToggle';
import pageBanner from '../../../assets/images/frontdesk-banner.webp';
import frontdeskImg2 from '../../../assets/images/frontdesk-booking-view.jpg';
import frontdeskImg3 from '../../../assets/images/frontdesk-reservations.jpg';
import frontdeskImg1 from '../../../assets/images/frontdesk-room-view.jpg';
import BackToTop from '../../BackToTop';
import FooterHomeThree from '../../Footer/FooterHomeThree';
import HeaderNews from '../../Header/HeaderNews';
import HeroNews from '../../Header/HeroNews';
import Drawer from '../../Mobile/Drawer';
import PreviewSlider from '../../PreviewSlider';
import ServicesAbout from './ServicesAbout';
import ShowCase from './ShowCase';

function Frontdesk() {
    const [drawer, drawerAction] = useToggle(false);
    return (
        <>
            <Helmet>
                <meta
                    name="description"
                    content="OTO Frontdesk provides comprehensive hotel management software for hotels in Kigali, Rwanda. Streamline front desk operations, manage reservations, automate housekeeping, and elevate guest experience with our efficient solutions. Contact us for a demo!"
                />
                <title>Efficient Hotel Management Solutions by OTO Frontdesk - Rwanda</title>
            </Helmet>
            <Drawer drawer={drawer} action={drawerAction.toggle} />
            <HeaderNews action={drawerAction.toggle} />
            <HeroNews
                title="Frontdesk : Rooms & Reservations"
                breadcrumb={[
                    { link: '/', title: 'Home' },
                    { link: '/apps', title: 'Apps' },
                    { link: '/apps/frontdesk', title: 'Frontdesk' },
                ]}
            />

            <div className="container pt-90 pb-90" style={{ fontSize: '18px', lineHeight: '29px' }}>
                <h3 className="mb-4">Rooms & Reservations Management</h3>
                <p className="mb-3">
                    OTO Frontdesk provides you with an intuitive interface to manage rooms and
                    reservations, making it easy to keep track of bookings, availability, and
                    pricing.
                </p>
                <p>
                    Suitable for small bed and breakfasts, small hotels, medium and large hotels.
                    With our app, you can simplify the reservation process, improve efficiency, and
                    provide a better guest experience.
                </p>
                <p>
                    Additionally our room management app and POS app are designed to work seamlessly
                    together, providing you with a single system to manage all aspects of your hotel
                    operations
                </p>

                <img
                    className="page-banner-img mt-4"
                    src={pageBanner}
                    alt="OTO Inventory Software"
                />
            </div>
            <ServicesAbout />

            <ShowCase />
            <div className="container">
                <PreviewSlider
                    images={[
                        { url: frontdeskImg1, alt: 'Frontdesk Rooms List' },
                        { url: frontdeskImg2, alt: 'Frontdesk Booking View' },
                        { url: frontdeskImg3, alt: 'Frontdesk Reservations' },
                    ]}
                />
            </div>
            <div className="container pt-60 pb-80 text-center">
                <div className="mx-auto" style={{ maxWidth: '800px' }}>
                    <p>
                        Are you tired of managing room reservations and bookings manually? Do you
                        struggle to keep track of room availability and pricing? OTO Frontdesk
                        software is here to help.
                    </p>
                </div>
            </div>
            <FooterHomeThree className="appie-footer-about-area" />
            <BackToTop />
        </>
    );
}

export default Frontdesk;
